import { CLAIM_TYPES, FIELD_GROUPS, STORY_FIELDS } from "@/lib/hyundaiFields";

export const HYUNDAI = {
  key: "hyundai", api: "/hyundai", title: "Hyundai Claim Portal", system: "WebDCS", make: "Hyundai",
  blurb: "Upload repair orders - AI drafts every WebDCS claim field and flags return risks from the Hyundai Claims Processing Manual.",
  header: "#002C5F", accent: "#00AAD2", typeKey: "claim_type", types: CLAIM_TYPES, groups: FIELD_GROUPS, story: STORY_FIELDS,
  yesNo: ["goodwill", "Goodwill requested"], causal: false, stores: true,
  cols: { id: "claim_number", idLabel: "Claim #", ro: "ro_number", roLabel: "R.O. #", op: "op_code" },
};

export const GM = {
  key: "gm", api: "/gm", title: "GM Claim Portal", system: "GWM", make: "GM",
  blurb: "Upload repair orders - AI drafts every Global Warranty Management transaction field and flags GM rejects (18-NA-146, causal part, OLH, field actions).",
  header: "#0b1f3a", accent: "#0170CE", typeKey: "transaction_type",
  types: ["ZREG", "ZFAT", "ZTPT", "ZPDI", "ZPTI", "ZPTC", "ZSET", "ZSSP"],
  yesNo: ["addon", "Add-on repair"], causal: true, codesApi: "/gm/codes", advisors: true, stores: true,
  cols: { id: "job_card", idLabel: "Job Card #", ro: "ro_full", roLabel: "RO", op: "labor_op" },
  groups: [
    { title: "Header", fields: [["job_card", "Job Card Number"], ["line", "Line Number"], ["vin", "VIN"], ["odometer", "Odometer"],
      ["advisor_number", "Service Advisor Number"], ["tech_number", "Tech # from RO (if not in list)"], ["open_date", "Open Date MMDDYYYY"], ["completion_date", "Completion Date MMDDYYYY"],
      ["labor_op", "Labour Operation Code"], ["reference_number", "Reference Number"], ["campaign", "Field action #"]] },
    { title: "Codes", fields: [["complaint_code", "Customer Complaint Code", "complaint"], ["cause_code", "Cause Code", "cause"],
      ["causal_part", "Causal Part Number"], ["dtcs", "DTCs"]] },
    { title: "Labour time", fields: [["base_time", "Base Labour Time"], ["diagnosis_time", "Diagnosis Time"],
      ["additional_time", "Additional Time"], ["olh_time", "Other Labour Time (OLH)"]] },
    { title: "Extras", fields: [["net_items", "Net Items (type amount; ...)"], ["authorization", "Authorization"]] },
  ],
  story: [["complaint_desc", "Customer Complaint Description"], ["cause_desc", "Cause Description"],
    ["correction", "Correction Description"], ["comments", "General Comments"]],
};
